import { render } from "./RateBlock.vue?vue&type=template&id=404d581a&scoped=true&ts=true"
import script from "./RateBlock.vue?vue&type=script&lang=ts"
export * from "./RateBlock.vue?vue&type=script&lang=ts"

import "./RateBlock.vue?vue&type=style&index=0&id=404d581a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-404d581a"]])

export default __exports__